import React, { useState } from "react";

import { InputAdornment, Select, SelectChangeEvent } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { countryList } from "../../internationalPhoneCodes";
import TextFieldWithValidation from "./TextFieldWithValidation";

const useStyles = makeStyles()((theme: any) => ({
  selectElement: {
    "& .MuiNativeSelect-root": {
      marginRight: theme.spacing(1),
    },
    "& .MuiNativeSelect-select": {
      backgroundColor: "#F2F2F2",
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(14),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(2.5),
      paddingTop: theme.spacing(0.75),
      paddingBottom: theme.spacing(0.75),
      minWidth: "2em",
    },
    "& .MuiNativeSelect-icon": {
      left: "50%",
    },
  },
  inputElement: {
    paddingRight: theme.spacing(2),
  },
}));

interface ComponentPropsType {
  id: string;
  country: string | undefined;
  changePhoneCountry: (country: string) => void;
  [key: string]: any;
}

const PhoneFieldWithValidation = (props: ComponentPropsType) => {
  const { changePhoneCountry, ...rest } = props;
  const { classes } = useStyles();

  const [showExpandedOptions, setShowExpandedOptions] = useState(false);

  const countryDropdownList = countryList.map((country) => {
    return (
      <option key={country.iso2} value={country.iso2}>
        {showExpandedOptions
          ? `${country.name} +${country.dialCode}`
          : `${country.iso2}`}
      </option>
    );
  });

  const expandOptions = () => {
    setShowExpandedOptions(true);
  };

  const handleChange = (event: SelectChangeEvent<string>) => {
    const newCountry = event.target.value;
    if (newCountry !== props.country) {
      changePhoneCountry(newCountry);
    }
  };

  const reduceOptions = () => {
    setShowExpandedOptions(false);
  };

  return (
    <TextFieldWithValidation
      {...rest}
      shrinkLabel={true}
      showCountryList={
        <InputAdornment position="start" className={classes.inputElement}>
          <Select
            native
            id={`select-country-${props.id}`}
            name="phoneCountry"
            value={props.country}
            onChange={handleChange}
            onFocus={expandOptions}
            onBlur={reduceOptions}
            className={classes.selectElement}
          >
            {countryDropdownList}
          </Select>
        </InputAdornment>
      }
    />
  );
};

export default PhoneFieldWithValidation;
